var CustomAuthProvider = (function () {
    function CustomAuthProvider() {
    }
    CustomAuthProvider.TYPE = "custom-token";
    CustomAuthProvider.DEFAULT_NAME = "custom-token";
    return CustomAuthProvider;
}());
export default CustomAuthProvider;
//# sourceMappingURL=CustomAuthProvider.js.map